import RadioGroup from "components/DesignSystem/RadioGroup/RadioGroup";

export const PricingTierSelector = ({
  pricingTier,
  pricingTierOptions,
  turnaround,
  onChange,
}: {
  pricingTier: string;
  pricingTierOptions: { value: string; label: string }[];
  turnaround: Record<string, string>;
  onChange: (tier: string) => void;
}) => {
  return (
    <div className="t-col-span-2 t-flex t-flex-col t-gap-2">
      <span className="t-text-body-sm t-text-text-30">Pricing tier</span>
      <RadioGroup.Root value={pricingTier} onValueChange={onChange}>
        <RadioGroup.Content>
          {pricingTierOptions.map((option) => (
            <RadioGroup.Item
              key={option.value}
              value={option.value}
              className="t-mt-1"
              description={<span className="">{turnaround[option.value]}</span>}
            >
              <span className="t-text-body-sm">{option.label}</span>
            </RadioGroup.Item>
          ))}
        </RadioGroup.Content>
      </RadioGroup.Root>
    </div>
  );
};
